import React, { useState, useEffect, useRef } from 'react';
import { Row, Col, TabContent, TabPane, Nav, NavItem, NavLink, Button, FormGroup, InputGroup, Input, InputGroupAddon, InputGroupText } from 'reactstrap';
import classnames from 'classnames';
import { uploadFeesFile, getDivisions } from '../../API';
import LoadingSVG from '../../icons/Spinner-1s-200px.svg';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCircle } from '@fortawesome/free-regular-svg-icons';
import { faCheckCircle } from '@fortawesome/free-solid-svg-icons';

function ImportFees(props) {
    const [divisionId, setDivisionId] = useState(2);
    const [results, setResults] = useState(null);
    const [divisions, setDivisions] = useState([]);
    const [isLoadingDivisions, setIsLoadingDivisions] = useState(true);
    const [processingFile, setProcessingFile] = useState(false);
    const [overwriteFees, setOverwriteFees] = useState(false);
    const fileEl = useRef(null);
    const [file, setFile] = useState(null);

    useEffect(() => {
        fetchDivisions();
    }, []);

    const fetchDivisions = async () => {
        setIsLoadingDivisions(true);

        const divisionsResult = await getDivisions();
        setDivisions(divisionsResult);

        setIsLoadingDivisions(false);
    };

    const toggleOverwrite = () => setOverwriteFees(!overwriteFees);

    const updateFile = (e) => {
        setFile(e.target.files[0]);
    };

    const processFile = async () => {
        try {
            setResults(null);
            setProcessingFile(true);

            const formData = new FormData();

            // Update the formData object
            formData.append(
                "DivisionID",
                divisionId
            );
            formData.append(
                "OverwriteFees",
                overwriteFees
            );
            formData.append(
                "FileToUpload",
                file,
                file.name
            );

            //formData.append("divisionId", divisionId);

            const response = await uploadFeesFile(formData);
            console.log(response);

            setResults({ success: true, ...response });
            //setResults({ success: !results?.success ?? false, recordsAdded: 3, recordsUpdated: 12 });
        } catch (ex) {
            console.log(ex);
            setResults({ success: false, message: 'Failed to import file.' });
        } finally {
            setProcessingFile(false);
        }
    }

    let resultsJSX = null;
    if (results) {
        if (results.success) {
            resultsJSX = (
                <div className="import-results success">
                    <span>{results.accountRecordsAdded} account records added.</span>
                    <span>{results.accountRecordsUpdated} account records updated.</span>
                    <span>{results.feeRecordsAdded} fee records added.</span>
                    <span>{results.feeRecordsUpdated} fee records updated.</span>
                </div>
            );
        } else {
            resultsJSX = (
                <div className="import-results failure">
                    <span>{results.message}</span>
                </div>
            );
        }
    }

    return (
        <div id="importAccounts" className="import-content">
            <div className="import-inputs">
                <FormGroup>
                    <InputGroup className="tooltip-parent">
                        <InputGroupAddon addonType="prepend">
                            <InputGroupText><i className="fas fa-users"></i></InputGroupText>
                        </InputGroupAddon>
                        <Input type="select" name="divisionId" value={divisionId} onChange={(e) => setDivisionId(+e.target.value)}>
                            {divisions.map(d => (<option value={d.divisionID} key={d.divisionID}>{d.divisionName}</option>))}
                        </Input>
                        <div className="tooltip-target tooltip-top">
                            DANR Program
                        </div>
                    </InputGroup>
                </FormGroup>
                <div className="template-selector tooltip-parent">
                    <div className="exclude-check">
                        <div onClick={toggleOverwrite} className="action-icon">
                            <FontAwesomeIcon icon={overwriteFees ? faCheckCircle : faCircle} />
                        </div>
                        <span>Overwrite Existing Fees</span>
                    </div>
                    <div className="tooltip-target tooltip-top">
                        Overwrite Fees
                    </div>
                </div>
                <FormGroup>
                    <div className="tooltip-parent">
                        <Input type="file" ref={fileEl} onChange={updateFile} />
                        <div className="tooltip-target tooltip-top">
                            Fees File
                        </div>
                    </div>
                </FormGroup>
            </div>
            <div className="import-buttons">
                <Button className="btn-block btn-icon" color="danr-green" onClick={processFile} disabled={processingFile}><i className="fas fa-upload"></i><span>Process File</span></Button>
            </div>
            {resultsJSX}
            {processingFile ? (<div className="loading"><img src={LoadingSVG} alt="Loading..." /></div>) : null}
        </div>
    );
}

export default ImportFees;